import { render } from "./MenuRecherche.vue?vue&type=template&id=008da493"
import script from "./MenuRecherche.vue?vue&type=script&lang=js"
export * from "./MenuRecherche.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__